import { TransactionMaterial } from "fe-shared-transactions/src/types";
import { MaterialCategoryName } from "fe-shared/src/types/domain";
import { AdjustmentMaterial } from "./types";

export const mapMaterialsToForm = (
  materials: TransactionMaterial[]
): AdjustmentMaterial[] => {
  return materials.map((material, index) => ({
    key: index,
    isOriginal: true,
    materialCode: material.materialCode,
    materialName: material.materialName,
    units: material.units,
  }));
};

export const filterMaterialsByCategory = (
  materials: TransactionMaterial[],
  materialCategoryName: MaterialCategoryName
): TransactionMaterial[] => {
  return materials.filter(
    (material) => material.materialCategoryName === materialCategoryName
  );
};

export default {
  mapMaterialsToForm,
  filterMaterialsByCategory,
};
